var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#2F75DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.222 15.9999H7.88867M25.222 15.9999V21.1999C25.222 21.6596 25.0394 22.1004 24.7143 22.4255C24.3893 22.7506 23.9484 22.9332 23.4887 22.9332H9.62201C9.1623 22.9332 8.72142 22.7506 8.39635 22.4255C8.07129 22.1004 7.88867 21.6596 7.88867 21.1999V15.9999M25.222 15.9999L22.232 10.0285C22.0885 9.73974 21.8673 9.49672 21.5932 9.32677C21.3192 9.15682 21.0031 9.0667 20.6807 9.06653H12.43C12.1075 9.0667 11.7915 9.15682 11.5174 9.32677C11.2434 9.49672 11.0222 9.73974 10.8787 10.0285L7.88867 15.9999M11.3553 19.4665H11.364M14.822 19.4665H14.8307",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5H24.5V22L17 22.5V16.5Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDevices);
export default __webpack_public_path__ + "static/media/activeDevices.9df7a94f09469b030640ced49917cf11.svg";
export { ForwardRef as ReactComponent };